<template>
  <b-container fluid>
    <page-title icon="fas fa-user-tie">
      <translate>Companies</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" :to="{name: 'CompaniesCreate'}">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Company</translate>
        </b-button>
      </template>
    </page-title>
    <api-list type="companies" :model="models.companies" :quick-filters="quickFiltersSetup.companies" />
  </b-container>
</template>
<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'CompanyList',
  title() {
    return this.$gettext('Companies')
  },
  components: {
    ApiList
  }
}
</script>
